import _defineProperty from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _variantType, _variantStyle;

import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Page/page';
import { css } from '@patternfly/react-styles';
import { formatBreakpointMods } from '../../helpers/util';
export var PageSectionVariants;

(function (PageSectionVariants) {
  PageSectionVariants["default"] = "default";
  PageSectionVariants["light"] = "light";
  PageSectionVariants["dark"] = "dark";
  PageSectionVariants["darker"] = "darker";
})(PageSectionVariants || (PageSectionVariants = {}));

export var PageSectionTypes;

(function (PageSectionTypes) {
  PageSectionTypes["default"] = "default";
  PageSectionTypes["nav"] = "nav";
})(PageSectionTypes || (PageSectionTypes = {}));

var variantType = (_variantType = {}, _defineProperty(_variantType, PageSectionTypes.default, styles.pageMainSection), _defineProperty(_variantType, PageSectionTypes.nav, styles.pageMainNav), _variantType);
var variantStyle = (_variantStyle = {}, _defineProperty(_variantStyle, PageSectionVariants.default, ''), _defineProperty(_variantStyle, PageSectionVariants.light, styles.modifiers.light), _defineProperty(_variantStyle, PageSectionVariants.dark, styles.modifiers.dark_200), _defineProperty(_variantStyle, PageSectionVariants.darker, styles.modifiers.dark_100), _variantStyle);
export var PageSection = function PageSection(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'default' : _a$variant,
      _a$type = _a.type,
      type = _a$type === void 0 ? 'default' : _a$type,
      padding = _a.padding,
      isFilled = _a.isFilled,
      props = __rest(_a, ["className", "children", "variant", "type", "padding", "isFilled"]);

  return React.createElement("section", Object.assign({}, props, {
    className: css(variantType[type], formatBreakpointMods(padding, styles), variantStyle[variant], isFilled === false && styles.modifiers.noFill, isFilled === true && styles.modifiers.fill, className)
  }), children);
};